import React, { useState } from 'react'
import Load from '../Load/Load'
import { message} from 'antd'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { updateUser, updateUserAdminStatus } from '../../Web Apis/webApis'
// import { MdSignalWifiStatusbar1Bar } from 'react-icons/md'


const EditAdmins = ({ showEditAdmin, setShowEditAdmin, selectedAdmin, action, setAction }) => {

    const [open, setOpen] = useState(showEditAdmin)
    const [loading, setLoading] = useState(false)
    

    const closeEditModal = () => {
        setOpen(false)
        setShowEditAdmin(false)
    }



    const formik = useFormik({
        initialValues: {
            name: selectedAdmin.name || '',
            isAdmin: selectedAdmin.isAdmin || false,
            active: selectedAdmin.active,
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Name is required").max(50, "Name should not be more than 50 characters").min(2, "Name should be atleast 2 characters long").trim(),
        }),

        onSubmit: async (values, { resetForm, setSubmitting }) => {
            setLoading(true)
            try {
                const userId = selectedAdmin._id || selectedAdmin.id;

                // Update user name and active status
                const userUpdateResponse = await updateUser(userId, {
                    name: values.name,
                    active: values.active
                });

                // Update admin status separately
                const adminStatusResponse = await updateUserAdminStatus(userId, values.isAdmin);

                if (userUpdateResponse?.data?.success && adminStatusResponse?.data?.success) {
                    message.success("User updated successfully");
                    resetForm()
                    setOpen(false)
                    setShowEditAdmin(false)
                    setAction(!action)
                } else {
                    throw new Error("Failed to update user");
                }

            } catch (error) {
                console.log("Error while edit user", error.message)
                message.error(error?.response?.data?.message || "Error while edit user profile")
            } finally {
                setSubmitting(false)
                setLoading(false)
            }
        }
    })




    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg w-[500px] h-[450px] overflow-y-auto">
                <h3 className="text-xl font-bold mb-1 text-center bg-gradient-to-br from-teal-950 to-teal-500 py-2 text-white">
                    Edit User
                </h3>
                <form onSubmit={formik.handleSubmit} className='p-8'>

                    <div className="w-full">
                        <label className="block mb-2">
                            Name:
                            <input
                                type="text"
                                name="name"
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className="block w-full p-3 border border-gray-800 bg-white rounded-md mt-1"
                                placeholder="Enter user name"
                            />
                        </label>
                        {formik.touched.name && formik.errors.name && (
                            <div className="text-red-500 text-sm mt-1">{formik.errors.name}</div>
                        )}
                    </div>

                    <div className="w-full mt-4">
                        <label className="block mb-2">
                            Role:
                            <select
                                name="isAdmin"
                                value={formik.values.isAdmin ? 'Admin' : 'User'}
                                onChange={(e) => {
                                    const isAdminValue = e.target.value === "Admin" ? true : false;
                                    formik.setFieldValue('isAdmin', isAdminValue);
                                }}
                                className="block w-full p-3 border border-gray-800 bg-white rounded-md mt-1"
                            >
                                <option value="User">Regular User</option>
                                <option value="Admin">Admin</option>
                            </select>
                        </label>
                    </div>

                    <div className="w-full mt-4">
                        <label className="block mb-2">
                            Status:
                            <select
                                name="active"
                                value={(formik.values.active === true) ? 'Active' : 'Inactive'}
                                onChange={(e) => {
                                    const isActive = e.target.value === "Active" ? true : false;
                                    formik.setFieldValue('active', isActive);
                                }}
                                className="block w-full p-3 border border-gray-800 bg-white rounded-md mt-1"
                            >
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                        </label>
                    </div>

                    <div className="flex justify-end gap-6 mt-8">
                        <button onClick={closeEditModal} className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200">
                            Close
                        </button>

                        <button type="submit" className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2">
                            {formik.isSubmitting ? "Updating..." : "Update User"}
                        </button>

                    </div>
                </form>
            </div>
            {loading && <Load/>}
        </div>
    )
}

export default EditAdmins